import { Util } from "src/app/shared/utils/util";
export class HistoricoReadaptacao {
  public tipo: string;
  public dataFim: Date;
  public status: string;
  public dataInicio: Date;
  public responsavel: string;
  public justificativa: string;
  public periodoReadaptacao: string;

  constructor(model?: any) {
    if (model) {
      Object.assign(this, model);
      this.periodoReadaptacao = Util.getDataReadaptacaoFormatada(model);
      this.dataInicio = model?.dataInicio ? new Date(model.dataInicio) : null;
      this.dataFim = model?.dataFim ? new Date(model.dataFim) : null;
    }
  }
}
